import { Typography } from "antd";
const { Title } = Typography;

export default function Footer(args) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",

        width: "100vw",
        backgroundColor: "#d3d3d309",
        marginTop: "3rem",
      }}
    >
      <Title
        style={{
          color: "#0b1425ff",
          fontSize: !(args.device === "phone")
            ? "calc(10px + .5vw)"
            : "calc(1rem + 1vw)",
          fontFamily: "Arial",
          textAlign: "center",
          margin: ".2rem 0",
        }}
      >
        © 2025 Zenofy Yazılım (Beta). Tüm hakları saklıdır.
      </Title>
    </div>
  );
}
